type Mastery = {
  completedCount: number;
  mastered: boolean;
  nextReviewOn: string | null;
};

export type DrillPracticeGroup = "ready" | "waiting" | "mastered";

export function japanPracticeDay(now = new Date()) {
  return new Date(now.getTime() + 9 * 60 * 60 * 1000)
    .toISOString()
    .slice(0, 10);
}

// Keep the same Japanese calendar day as the mastery schedule, including when
// the player is using a device in a different timezone.
export function drillPracticeGroup(
  mastery: Mastery,
  now = new Date(),
): DrillPracticeGroup {
  if (mastery.mastered) return "mastered";
  const today = japanPracticeDay(now);
  return mastery.completedCount > 0 &&
    mastery.nextReviewOn !== null &&
    mastery.nextReviewOn > today
    ? "waiting"
    : "ready";
}

// Input is already ordered by the saved position, creation date and id.
// Ready reviews come before unstarted drills. Preserve the supplied base order
// within those two subgroups, as well as waiting and mastered drills.
export function groupDrillsForPractice<T extends { mastery: Mastery }>(
  drills: readonly T[],
  now = new Date(),
) {
  const groups: Record<DrillPracticeGroup, T[]> = {
    ready: [],
    waiting: [],
    mastered: [],
  };
  const unstarted: T[] = [];
  for (const drill of drills) {
    const group = drillPracticeGroup(drill.mastery, now);
    if (group === "ready" && drill.mastery.completedCount === 0)
      unstarted.push(drill);
    else groups[group].push(drill);
  }
  groups.ready = groups.ready.concat(unstarted);
  return (["ready", "waiting", "mastered"] as const).map((id) => ({
    id,
    drills: groups[id],
  }));
}
